import { PhotoIdentifiers } from '@/types/attachments/photo';
import { Route } from 'vue-router';
import { PermissionsGroupName } from '@/constants/permissions';

export const photoRoutes = [
  {
    name: 'Photos',
    path: 'photos',
    redirect: { name: 'PhotosSearch' },
    meta: {
      pageTitle: 'Photos',
      permission: PermissionsGroupName.PHOTOS,
    },
    component: () => import('@/views/photo/PhotosLayout.vue'),
    children: [
      {
        name: 'PhotosSearch',
        path: 'search',
        meta: {
          pageTitle: 'Search',
          permission: PermissionsGroupName.PHOTOS,
        },
        component: () => import('@/views/photo/PhotosSearchView.vue'),
      },
      {
        name: 'PhotosView',
        path: 'view',
        meta: {
          pageTitle: 'View',
          permission: PermissionsGroupName.PHOTOS,
        },
        redirect: { name: 'PhotosSearch' },
        component: () => import('@/views/photo/PhotosDetailedView.vue'),
        children: [
          {
            name: 'MblPhotos',
            path: 'mbl/:id',
            meta: {
              pageTitle: 'MBL',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.MBL,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
          {
            name: 'HblPhotos',
            path: 'hbl/:id',
            meta: {
              pageTitle: 'HBL',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.HBL,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
          {
            name: 'OnHandPhotos',
            path: 'on-hand/:id',
            meta: {
              pageTitle: 'On Hand',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.ON_HAND,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
          {
            name: 'IpiLoadGuidePhotos',
            path: 'ipi-load-guide/:id',
            meta: {
              pageTitle: 'IPI Load Guide',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.IMPORT_LOAD_GUIDE,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
          {
            name: 'ExportLoadGuidePhotos',
            path: 'export-load-guide/:id',
            meta: {
              pageTitle: 'Export Load Guide',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.EXPORT_LOAD_GUIDE,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
          {
            name: 'AirMblPhotos',
            path: 'air-mbl/:id',
            meta: {
              pageTitle: 'AIR MBL',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.AIR_MBL,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
          {
            name: 'AirHblPhotos',
            path: 'air-hbl/:id',
            meta: {
              pageTitle: 'AIR HBL',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.AIR_HBL,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
          {
            name: 'InterfacilityLoadGuidePhotos',
            path: 'interfacility-load-guide/:id',
            meta: {
              pageTitle: 'Mixed Load Guide',
              permission: PermissionsGroupName.PHOTOS,
            },
            props: (route: Route) => ({
              id: route.params.id,
              entity: PhotoIdentifiers.INTERFACILITY_LOAD_GUIDE,
            }),
            component: () => import('@/components/attachments/photo/PhotoManifestDetails.vue'),
          },
        ],
      },
    ],
  },
];
